import { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "../services/auth";

import "../styles/auth.css";

export default function ForgotPassword() {

    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    async function handleSubmit(e) {

        e.preventDefault();
        setLoading(true);
        setError("");

        try {

            await forgotPassword(email);
            setSent(true);

        } catch (err) {

            // Backend always returns a generic success message even on
            // failure (so this endpoint can't be used to probe which
            // emails exist) - a network/server error is the only thing
            // that lands here.
            setError("Something went wrong. Please try again.");

        } finally {

            setLoading(false);

        }

    }

    return (

        <div className="authContainer">

            <div className="authCard">

                <h1>CercaTrova</h1>
                <p>Reset your password</p>

                {sent ? (

                    <p className="authInfoText">
                        If an account exists for <b>{email}</b>, a reset link
                        has been sent. Check your inbox (and spam folder).
                    </p>

                ) : (

                    <form onSubmit={handleSubmit}>

                        <input
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />

                        {error && <p className="authError">{error}</p>}

                        <button type="submit" disabled={loading}>
                            {loading ? "Sending..." : "Send Reset Link"}
                        </button>

                    </form>

                )}

                <p>
                    <Link to="/login">Back to Login</Link>
                </p>

            </div>

        </div>

    );

}
